import { FC, useRef, useEffect, useMemo } from 'react';
import { ReactComponent as CloseIcon } from './assets/popup_close.svg';
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import { ConfirmationForm } from 'components/PopUps/ConfirmDialog';
import { RequestPopUp } from 'components/PopUps/RequestPopUp';
import { ImageViewPopUp } from 'components/PopUps/ImageViewPopUp';
import { MapViewPopUp } from 'components/PopUps/MapViewPopUp';
import AdminUserPopUp from 'components/PopUps/AdminUserPopUp';
import { AddProductPopup } from 'components/PopUps/AddProductPopup';
import styles from './popup.module.scss';
import { ConfirmWithCodePopUp } from 'components/PopUps/ConfirmWithCodePopUp';
import { ImageOrganiserPopUp } from 'components/PopUps/ImageOrganiserPopUp';
import { ResyncPopUp } from 'components/PopUps/ResyncPopUp';

export const PopUp: FC = observer(() => {
  const {
    popUpStore: { open, closePopUp, formName },
  } = useStore();

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleKeyPressed = (event: KeyboardEvent) => {
      if (event?.code === 'Escape') {
        event.preventDefault();
        if (ref.current) {
          closePopUp();
        }
      }
    };

    document.addEventListener('keydown', handleKeyPressed);
    return () => {
      document.removeEventListener('keydown', handleKeyPressed);
    };
  }, []);

  const component = useMemo(() => {
    switch (formName) {
      case 'confirmation':
        return <ConfirmationForm />;
      case 'admin-user':
        return <AdminUserPopUp />;
      case 'request':
        return <RequestPopUp />;
      case 'imageView':
        return <ImageViewPopUp />;
      case 'mapView':
        return <MapViewPopUp />;
      case 'addProduct':
        return <AddProductPopup />;
      case 'confirmWithCode':
        return <ConfirmWithCodePopUp />;
      case 'organiserImages':
        return <ImageOrganiserPopUp />;
      case 'resyncElastic':
        return <ResyncPopUp />;
      default:
        return null;
    }
  }, [formName]);

  const shouldShowCloseButton = formName !== 'resyncElastic';

  return open ? (
    <div ref={ref} className={styles.popup}>
      <div className={styles.box}>
        <header className={styles.header}>
          {shouldShowCloseButton && (
            <button className={styles.btnClose} onClick={closePopUp}>
              <CloseIcon />
            </button>
          )}
        </header>
        <div className={styles.main}>{component}</div>
      </div>
    </div>
  ) : null;
});
